// @core/api/endpoints/calendar/get_booking_link_availability.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetBookingLinkAvailabilityResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Get booking availability
 * Returns available time slots for a booking link. This is a public endpoint that does not require authentication.
 */
export async function GetBookingLinkAvailability(
  slug: string,
  options?: RequestOptions
): Promise<GetBookingLinkAvailabilityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/public/booking/:slug/availability`;
  requestPath = requestPath.replace(':slug', encodeURIComponent(slug));
  const requestOptions = options;
  return client.get<GetBookingLinkAvailabilityResponse>(requestPath, { ...requestOptions });
}
